(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cross-sell-strip"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.__rwCsStrip) return;
  window.__rwCsStrip = true;

  function wire(strip) {
    if (strip.dataset.csInit) return;
    strip.dataset.csInit = '1';
    var track = strip.querySelector('[data-cs-track]');
    var nav = strip.querySelector('[data-cs-nav]');
    var prev = strip.querySelector('[data-cs-prev]');
    var next = strip.querySelector('[data-cs-next]');
    if (!track) return;

    function update() {
      var overflow = (track.scrollWidth - track.clientWidth) > 4;
      if (nav) nav.hidden = !overflow;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      var atEnd = (track.scrollLeft + track.clientWidth) >= (track.scrollWidth - 2);
      if (next) next.disabled = atEnd;
      // Drop the "more to come" fade once there's nothing further to scroll to
      // (and on strips too short to scroll at all).
      strip.setAttribute('data-cs-end', (atEnd || !overflow) ? 'true' : 'false');
    }
    function step(dir) {
      var card = track.querySelector('.cross-sells__item');
      var amt = card ? (card.getBoundingClientRect().width + 10) : track.clientWidth * 0.85;
      track.scrollLeft = Math.max(0, Math.min(track.scrollLeft + dir * amt, track.scrollWidth - track.clientWidth));
      update();
    }
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);

    var down = false, sx = 0, sl = 0, moved = false;
    track.addEventListener('mousedown', function (e) {
      down = true; moved = false; sx = e.pageX; sl = track.scrollLeft;
      track.classList.add('is-dragging'); e.preventDefault();
    });
    window.addEventListener('mouseup', function () { down = false; track.classList.remove('is-dragging'); });
    window.addEventListener('mousemove', function (e) {
      if (!down) return; var dx = e.pageX - sx; if (Math.abs(dx) > 3) moved = true; track.scrollLeft = sl - dx;
    });
    track.addEventListener('click', function (e) {
      // Suppress the click that ends a drag.
      if (moved) { e.preventDefault(); e.stopPropagation(); return; }
      // The theme's quick-add modal renders empty inside the cart, so route
      // variant products straight to their product page instead of opening a
      // broken sheet. Single-variant items keep their direct add-to-cart.
      var trigger = e.target.closest('[data-quick-add-trigger]');
      if (trigger) {
        var url = trigger.getAttribute('data-product-url');
        if (url) { e.preventDefault(); e.stopPropagation(); window.location.href = url; }
      }
    }, true);

    update();
    setTimeout(update, 300);
  }

  function scan() { document.querySelectorAll('[data-cs-strip]').forEach(wire); }
  if (document.readyState !== 'loading') scan(); else document.addEventListener('DOMContentLoaded', scan);
  var t;
  var mo = new MutationObserver(function () { clearTimeout(t); t = setTimeout(scan, 200); });
  mo.observe(document.body, { childList: true, subtree: true });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-item"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.__rwCardVideo) return;
  window.__rwCardVideo = true;
  if (!('IntersectionObserver' in window)) return;

  function play(v, hold) {
    v.muted = true;
    var go = function () {
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
      v.classList.add('is-playing');
    };
    if (v.readyState >= 2) { go(); }
    else { try { v.load(); } catch (e) {} v.addEventListener('canplay', go, { once: true }); }
    clearTimeout(v._rwStop);
    // Scroll: play a ~5s clip then settle back. Hover (hold): keep playing until mouse-out.
    if (!hold) { v._rwStop = setTimeout(function () { v.pause(); v.classList.remove('is-playing'); }, 5000); }
  }
  function reset(v) {
    clearTimeout(v._rwEnter);
    clearTimeout(v._rwStop);
    v.pause();
    try { v.currentTime = 0; } catch (e) {}
    v.classList.remove('is-playing');
  }
  // Preload the clip well before it enters view so it's buffered and plays instantly.
  var pre = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting) {
        var v = en.target;
        if (v.preload !== 'auto') { v.preload = 'auto'; try { v.load(); } catch (e) {} }
        pre.unobserve(v);
      }
    });
  }, { rootMargin: '600px 0px' });

  // Play once the card is meaningfully in view for a short beat.
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      var v = en.target;
      v._rwInView = en.isIntersecting;
      if (en.isIntersecting) {
        clearTimeout(v._rwEnter);
        v._rwEnter = setTimeout(function () { play(v); }, 1400);
      } else {
        reset(v);
      }
    });
  }, { threshold: 0.4 });

  function scan() {
    document.querySelectorAll('video.product-item__card-video:not([data-rw-obs])').forEach(function (v) {
      v.setAttribute('data-rw-obs', '1');
      v.muted = true; v.playsInline = true; v.loop = true;
      pre.observe(v);
      io.observe(v);

      // Hover plays it straight away and holds while the mouse is over the card.
      // Bind hover to the whole card, not just the media box: the quick-add button sits
      // over the image, and hovering it would otherwise fire mouseleave and kill playback.
      var host = v.closest('.product-item') || v.closest('.product-item__media') || v.parentNode;
      if (host) {
        host.addEventListener('mouseenter', function () {
          if (v.preload !== 'auto') { v.preload = 'auto'; try { v.load(); } catch (e) {} }
          clearTimeout(v._rwEnter);
          play(v, true);
        });
        host.addEventListener('mouseleave', function () {
          reset(v);
          if (v._rwInView) { v._rwEnter = setTimeout(function () { play(v); }, 1400); }
        });
      }

      // Tap-to-unmute (mobile especially). Keeps playing once you've opted into sound.
      var muteBtn = (host || v.parentNode).querySelector('.product-item__video-mute');
      if (muteBtn) {
        muteBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          v.muted = !v.muted;
          muteBtn.classList.toggle('is-unmuted', !v.muted);
          muteBtn.setAttribute('aria-label', v.muted ? 'Unmute video' : 'Mute video');
          if (!v.muted) {
            clearTimeout(v._rwStop);
            if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); v.classList.add('is-playing'); }
          }
        });
      }
    });
  }
  if (document.readyState !== 'loading') scan(); else document.addEventListener('DOMContentLoaded', scan);
  var t;
  var mo = new MutationObserver(function () { clearTimeout(t); t = setTimeout(scan, 300); });
  mo.observe(document.body, { childList: true, subtree: true });
})();
(function () {
  if (window.__rwQuickAdd) return;
  window.__rwQuickAdd = true;

  var TOAST_ID = 'rw-added-toast';

  function toast(message) {
    var el = document.getElementById(TOAST_ID);
    if (!el) {
      el = document.createElement('div');
      el.id = TOAST_ID;
      el.className = 'rw-added-toast';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      document.body.appendChild(el);
    }
    el.innerHTML =
      '<svg class="rw-added-toast__tick" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg>' +
      '<span></span>';
    el.querySelector('span').textContent = message;
    // Force a reflow so the transition runs even when the toast is reused.
    void el.offsetWidth;
    el.classList.add('is-visible');
    clearTimeout(el._rwTimer);
    el._rwTimer = setTimeout(function () { el.classList.remove('is-visible'); }, 2600);
  }

  function notifyCart() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('quick-cart:updated', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart }, bubbles: true }));
      })
      .catch(function () {});
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-rw-quickadd]');
    if (!btn || btn.disabled) return;

    // The whole card is a link — don't let the click navigate away.
    e.preventDefault();
    e.stopPropagation();

    var title = btn.getAttribute('data-title') || 'Item';
    var originalIcon = btn.innerHTML;
    var tick = '<svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg>';
    var id = btn.getAttribute('data-variant-id');
    if (!id) return;

    btn.disabled = true;
    btn.classList.add('is-busy');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function () {
        btn.classList.remove('is-busy');
        btn.classList.add('is-done');
        btn.innerHTML = tick;
        toast(title + ' added to your basket');
        notifyCart();
        setTimeout(function () {
          btn.classList.remove('is-done');
          btn.innerHTML = originalIcon;
          btn.disabled = false;
        }, 1800);
      })
      .catch(function () {
        btn.classList.remove('is-busy');
        btn.title = 'Could not add — try again';
        setTimeout(function () { btn.disabled = false; btn.title = 'Add to basket'; }, 1800);
      });
  }, true);
})();
  } catch(e) { console.error(e); }
})();

})();
